import Model from "./Model";

export default class FileModel extends Model {
    constructor({name, ext, size, content} = {}) {
        super();

        this.addField({
            name: 'name',
            value: name || ''
        });

        this.addField({
            name: 'ext',
            value: ext || ''
        });

        this.addField({
            name: 'size',
            value: size || 0
        });

        this.addField({
            name: 'content',
            value: content || null,
            validation: {
                required: true
            }
        });

    }
}